<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <banner-component />
    <video-component />
    <petsintroduction-component />
    <ourServices-component />
    <petsProteen-component />
    <customerSlider-component />
    <gallerySlider-component />
    <mobileApp-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import bannerComponent from '../home/bannerComponent.vue';
import videoComponent from '../home/videoComponent.vue';
import petsintroductionComponent from '../home/petsintroductionComponent.vue';
import ourServicesComponent from '../home/ourServicesComponent.vue';
import petsProteenComponent from '../home/petsProteenComponent.vue';
import customerSliderComponent from '../home/customerSliderComponent.vue';
import gallerySliderComponent from '../home/gallerySliderComponent.vue';
import mobileAppComponent from '../home/mobileAppComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    bannerComponent,
    videoComponent,
    petsintroductionComponent,
    ourServicesComponent,
    petsProteenComponent,
    customerSliderComponent,
    gallerySliderComponent,
    mobileAppComponent,
    footerComponent,
  },
};
</script>
